import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const attach = (token: string | null) =>
    token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return from(authService.getIdToken()).pipe(
    switchMap((token) =>
      next(attach(token)).pipe(
        catchError((error) => {
          if (error instanceof HttpErrorResponse && error.status === 401 && token) {
            return from(authService.getIdToken(true)).pipe(
              switchMap((refreshedToken) => {
                if (!refreshedToken) {
                  authService.signOut();
                  router.navigate(['/auth/login']);
                  return throwError(() => error);
                }
                return next(attach(refreshedToken));
              })
            );
          }
          return throwError(() => error);
        })
      )
    )
  );
};
